// extracted by mini-css-extract-plugin
export default {"buttonContainer":"fOR3205VRTf3QCm7TVxa","ripple":"s59P5zNnL7667nbPBdho"};